import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../css/bootstrap-legacy-bridge.css';
import './bootstrap-legacy-bridge';

window.bootstrap = window.bootstrap || bootstrap;
